import React, { useEffect, useState, useRef } from 'react';
import './trainingpopup.scss';
import SSButton from '../SSButton';
import ReviewCarousel from '../ReviewCarousel';
import { DOMAIN } from '../../Constants/base';
import { putReq } from '../../utils/api';
import { postLogger } from '../../utils/analytics';
import { createEventSource, getSessionStorage, isValidWebsite, setNativeValue } from '../../utils';
import { trackEvents } from '../../utils/analytics';
import { toast } from 'react-toastify';

export default function TrainingPopUp({
  trainingStep,
  setOpenTrainingPopUp,
  persDesc,
  setPersDesc,
  companyDesc,
  setCompanyDesc,
  setGetNewAiDetails,
  isTrainAI,
  setIsTrainAI,
  getProfile,
  originalDescription,
  originalCompanyDescription,
}) {
  const [descriptionCount, setDescriptionCount] = useState(0);
  const userToken = JSON.parse(localStorage.getItem('ss-auth-sales')) || {};
  const [descValue, setDescValue] = useState('');
  const [currentStep, setCurrentStep] = useState(trainingStep ? trainingStep : 1);
  const [isUpdatingApi, setIsUpdatingApi] = useState(false);
  const [checkTextUpdate, setCheckTextUpdate] = useState(false);
  //state for toggling between manual and auto business train
  const [isBusinessManual, setIsBusinessManual] = useState(false);
  const [businessWebsiteUrl, setBusinessWebsiteUrl] = useState('');
  const [isValidURL, setIsValidURL] = useState(false);
  const [isAutoBusinessTrainStarted, setIsAutoBusinessTrainStarted] = useState(false);
  const [isVisible, setIsVisible] = useState([false, false, false]);
  const [isGeneratingBusinessDesc, setIsGeneratingBusinessDesc] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  const profiles = getSessionStorage('current-profile');
  const exampleRef = useRef(null);
  const textAreaRef = useRef(null);

  useEffect(() => {
    if (!isAutoBusinessTrainStarted) return;
    const timeouts = [1000, 2000, 3000, 4000]; // Add more timeouts if needed

    const updateVisibility = (index) => {
      setIsVisible((prev) => [...prev.slice(0, index), true, ...prev.slice(index + 1)]);
    };

    timeouts.forEach((timeout, index) => {
      setTimeout(() => updateVisibility(index), timeout);
    });

    setTimeout(() => {
      trainBusiness('auto');
    }, 4100);

    // Clean up timeouts to avoid memory leaks
    return () => timeouts.forEach(clearTimeout);
  }, [isAutoBusinessTrainStarted]);

  useEffect(() => {
    if (currentStep === 1) {
      setDescValue(persDesc);
      setDescriptionCount(persDesc?.length);
    } else if (currentStep === 2) {
      setDescValue(companyDesc);
      setDescriptionCount(companyDesc?.length);
    }
  }, [currentStep]);

  useEffect(() => {
    if (currentStep === 1) {
      setPersDesc(descValue);
    } else if (currentStep === 2) {
      setCompanyDesc(descValue);
    }
  }, [descValue]);

  const handlebackClick = () => {
    if (currentStep === 2 && isTrainAI) setCurrentStep(1);
    else {
      setIsTrainAI(false);
      setOpenTrainingPopUp(false);
    }
    if (currentStep === 2) {
      setCompanyDesc(originalCompanyDescription);
    } else if (currentStep === 1) {
      setPersDesc(originalDescription);
    }
  };

  const updateAITraining = async () => {
    if (isUpdatingApi) return;
    setIsUpdatingApi(true);
    let url = `${DOMAIN}/v1/user`;
    let requestHeaders = {
      authorization: `bearer ${userToken?.accessToken ? userToken?.accessToken : userToken}`,
    };

    let payload = {
      description: persDesc,
      companyDescription: companyDesc,
    };

    const setUpResp = await putReq({ url, requestHeaders, payload });
    const { code } = setUpResp;
    let timeoutCode = code.toString();
    timeoutCode = Array.from(timeoutCode)[0];
    if (code === 200) {
      if ((persDesc && currentStep === 1) || (companyDesc && currentStep === 2)) {
        trackEvents(currentStep === 1 ? 'trained_personal' : 'trained_professional', {
          userId: profiles.userId,
          is_admin: profiles.roleType === 'OWNER',
        });
        //GTM event
        window.dataLayer.push({
          event: 'train_ai',
          user_id: profiles.userId,
          ai_type: currentStep === 1 ? 'personal' : 'professional',
        });
      }

      setIsTrainAI(false);
      setIsUpdatingApi(false);
      setGetNewAiDetails(true);
      setOpenTrainingPopUp(false);
      getProfile();
    } else if (timeoutCode === '5') {
      let newPayload = {
        ...profiles,
        code,
      };
      postLogger('UPDATE_AI_TRAINING_DETAILS', newPayload);
    }
  };

  const callback = (text, retrainType) => {
    setIsDisabled(false);
    setDescValue(text);
    setNativeValue(textAreaRef.current, text);
    const inputEvent = new Event('input', { bubbles: true });
    textAreaRef.current.dispatchEvent(inputEvent);
  };
  const handleError = (error, retrainType) => {
    toast.error(error, {
      position: 'top-center',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
    });
  };

  const finishGeneration = ({}, retrainType) => {
    setIsGeneratingBusinessDesc(false);
    setIsAutoBusinessTrainStarted(false);
    setIsVisible([false, false, false, true]);
  };
  const updateLeActivity = () => {};

  const trackEvent = () => {};

  const rewrite = () => {};

  let evtRef = useRef(null);

  const trainBusiness = async (retrainType) => {
    let url = `${DOMAIN}/v1/user/training/business`;
    if (businessWebsiteUrl.length === 0) return;
    let payload = {
      websiteURL: businessWebsiteUrl,
    };

    const request = {
      url,
      payload,
      authToken: userToken?.accessToken ? userToken?.accessToken : userToken,
      callback,
      handleError,
      finishGeneration,
      updateLeActivity,
      trackEvent,
      rewrite,
      evtRef,
      retrainType,
    };
    setIsGeneratingBusinessDesc(true);
    createEventSource(request);
  };

  return (
    <div className="training-wrapper">
      <div className="footer-btns">
        <SSButton
          btnText={'back'}
          onClickHandle={() => {
            handlebackClick();
          }}
        ></SSButton>
        {isTrainAI && <div className="step-counter">{`${currentStep}/2 `}</div>}
        <SSButton
          isDisabled={!checkTextUpdate}
          btnText={'save'}
          type={'filled'}
          onClickHandle={() => {
            if (isTrainAI && currentStep === 1) {
              trackEvents('trained_personal', {
                userId: profiles.userId,
                is_admin: profiles.roleType === 'OWNER',
              });
              setCurrentStep(2);
            } else {
              updateAITraining();
            }
          }}
        ></SSButton>
      </div>
      <div translate="no" className="header">
        <h1>{currentStep === 1 ? 'Personal Training' : 'Business Training'}</h1>
        {/* <span onClick={() => exampleRef.current.scrollIntoView({ behavior: 'smooth' })}>SEE EXAMPLES</span> */}
      </div>
      {currentStep === 1 ? (
        <>
          <div translate="no" className="training-body">
            {/* <label>{currentStep === 1 ? 'DESCRIBE YOURSELF' : 'DESCRIBE YOUR COMPANY,SERVICE OR ROLE'}</label> */}
            <span className="text-length">
              <h4>We recommend min 530 characters </h4>
              <div>
                <span translate="no">{descriptionCount}</span>/530
              </div>
            </span>
            <textarea
              placeholder="Type here..."
              value={descValue}
              onChange={(e) => {
                setCheckTextUpdate(true);
                setDescValue(e.target.value);
                setDescriptionCount(e.target.value.length);
              }}
            ></textarea>
          </div>
          <div ref={exampleRef} className="footer">
            <div className="examples">
              <ReviewCarousel currentStep={currentStep} />
            </div>
          </div>
        </>
      ) : (
        <div className="training-wrapper-business">
          <div className="training-wrapper-business-input">
            <div className="business-input-wrapper">
              <div className="training-wrapper-business-input-text">
                <label>YOUR COMPANY’S WEBSITE</label>
                <input
                  placeholder="www.mycompany.com"
                  value={businessWebsiteUrl}
                  onChange={(e) => {
                    if (e.target.value.length > 0) {
                      setBusinessWebsiteUrl(e.target.value);
                      if (isValidWebsite(e.target.value)) {
                        setIsValidURL(true);
                      } else {
                        setIsValidURL(false);
                      }
                    } else {
                      setBusinessWebsiteUrl(e.target.value);
                      setIsValidURL(false);
                    }
                  }}
                />
              </div>
              <SSButton
                onClickHandle={() => setIsAutoBusinessTrainStarted(true)}
                isDisabled={!isValidURL || isGeneratingBusinessDesc || isDisabled || isAutoBusinessTrainStarted}
                btnText={'train'}
                type={'filled'}
                classBtn="auto-train"
              />
            </div>
            {!(isVisible[3] || isBusinessManual || originalCompanyDescription) && (
              <div className="training-wrapper-business-input-manual">
                <span>Don’t have a website?</span>
                <a onClick={() => setIsBusinessManual(true)}>ENTER DESCRIPTION MANUALLY</a>
              </div>
            )}
          </div>
          {isAutoBusinessTrainStarted && (
            <div className="training-wrapper-business-steps">
              <div
                className={`training-wrapper-business-steps-group`}
                style={{
                  visibility: isVisible[0] ? 'visible' : 'hidden',
                }}
              >
                <span>Gathering insights from your website</span>
                <span>&#10004;</span>
              </div>
              <div
                className={`training-wrapper-business-steps-group`}
                style={{
                  visibility: isVisible[1] ? 'visible' : 'hidden',
                }}
              >
                <span>Understanding your company</span>
                <span>&#10004;</span>
              </div>
              <div
                className={`training-wrapper-business-steps-group`}
                style={{
                  visibility: isVisible[2] ? 'visible' : 'hidden',
                }}
              >
                <span>Summarising</span>
                <span>&#10004;</span>
              </div>
            </div>
          )}
          {(isVisible[3] || isBusinessManual || originalCompanyDescription) && (
            <div translate="no" className="training-body">
              {/* <label>{currentStep === 1 ? 'DESCRIBE YOURSELF' : 'DESCRIBE YOUR COMPANY,SERVICE OR ROLE'}</label> */}
              <span className="text-length">
                <h4>We recommend min 530 characters </h4>
                <div>
                  <span translate="no">{descriptionCount}</span>/530
                </div>
              </span>
              <textarea
                ref={textAreaRef}
                placeholder="Type here..."
                value={descValue}
                onChange={(e) => {
                  setCheckTextUpdate(true);
                  setDescValue(e.target.value);
                  setDescriptionCount(e.target.value.length);
                }}
              ></textarea>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
